import React, { useMemo } from "react";
import Form from "../Form/Form.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import RichTextEditorField from "../Form/RichTextEditorField.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";
import parse from "html-react-parser";
import config from "config";

import "./editEmailModal.scss";

const AdditionalInfoElement = ({ props }) => {
  const { getTextByKey, getPath } = useContent();
  return (
    <div className="additional-info-text">
      {parse(
        getTextByKey("additional-info-text").replace(
          "#link#",
          `${config.baseurl}${getPath()}user/branding/cover-logo`
        )
      )}
    </div>
  );
};

const fields = {
  editEmailSubject: {
    element: "input",
    fieldKey: "editEmailSubject",
    type: "text",
    title: "editEmailSubject",
    label: "subject",
  },
  editEmailBody: {
    element: "customelement",
    fieldKey: "editEmailBody",
    validation: {
      maxLength: 2000,
    },
    render: (props) => (
      <RichTextEditorField {...props} alwaysShowTools={true} />
    ),
  },
  userNameDisplay: {
    fieldKey: "userNameDisplay",
    element: "checkbox",
    title: "userNameDisplay",
    label: "display-mail-username",
    className: "edit-mail-checkbox",
  },
  subjectDisplay: {
    fieldKey: "subjectDisplay",
    element: "checkbox",
    title: "subjectDisplay",
    label: "display-mail-subject",
    className: "edit-mail-checkbox",
  },
  additionalInfoText: {
    element: "customelement",
    fieldKey: "additionalInfoText",
    render: (props) => <AdditionalInfoElement props={props} />,
  },
};

const EditEmailModal = ({
  subject,
  message,
  emailId,
  callbackUpdateProps,
  userNameDisplay,
  subjectDisplay,
}) => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  const { addToast } = useToasts();

  const handleSubmit = async (body) => {
    const res = await apiRequest(
      "Mails",
      "ReactSetSubjectAndText",
      {
        subject: body.editEmailSubject,
        body: body.editEmailBody,
        encryptedMailId: emailId,
        recaptchaResponse: body.recaptchaResponse,
        displayNameOnGallery: body.userNameDisplay,
        displayEmailSubjectOnGallery: body.subjectDisplay,
      },
      "POST"
    );
    if (res.status === "success") {
      closeModal();
      addToast(getTextByKey("email-details-updated"), {
        appearance: "success",
      });
      callbackUpdateProps({
        subjectValue: body.editEmailSubject,
        messageValue: body.editEmailBody,
        displaySenderName: body.userNameDisplay,
        displaySubject: body.subjectDisplay,
      });
      return {
        status: res.status,
      };
    }
    return {
      status: res.status,
      message: res.data,
    };
  };

  const handleCancel = () => {
    closeModal();
  };

  // added useMemo cos on dissapear of toast message it re-rendered the modal and the form was reset
  return useMemo(
    () => (
      <div className="edit-email-modal">
        <Form
          fields={fields}
          onSubmit={handleSubmit}
          submitProps={{
            title: getTextByKey("save"),
            errorWithBackground: true,
          }}
          buttonProps={{ buttonsSize: "large" }}
          cancelProps={{
            title: getTextByKey("cancel"),
            className: "blank-button",
          }}
          onCancel={handleCancel}
          defaultValuesObj={{
            editEmailSubject: subject,
            editEmailBody: message,
            subjectDisplay: subjectDisplay,
            userNameDisplay: userNameDisplay,
          }}
        />
      </div>
    ),
    []
  );
};

export default EditEmailModal;
